// extracted by mini-css-extract-plugin
export var actions = "ErrorModal-module--actions--2e499";
export var content = "ErrorModal-module--content--4fb8c";
export var message = "ErrorModal-module--message--fe626";